import { Service } from "typedi";
import { DeviceStatusDTO } from "../../../../../schools-backend/src/student/application/dtos/StudentDeviceStatusDTO";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { DeviceStatusCache } from "../state/DeviceStatusCache";

@Service()
export class SetStudentDeviceStatus implements AgentRPCCommand<"set.student.device.status"> {
    constructor(
        agentRPCCommands: AgentRPCCommands,
        private readonly deviceStatusCache: DeviceStatusCache
    ) {
        agentRPCCommands.register("set.student.device.status", this);
    }

    async run(deviceStatus: DeviceStatusDTO): Promise<void> {
        this.deviceStatusCache.set(deviceStatus);
    }
}
